import React, { Component } from "react";
import "./InfoSubheader.css";

export default class InfoSubheader extends Component {

    render() {
        const { children } = this.props;
        return (
            <div className="InfoSubheader">
                {children}
            </div>
        );
    }

}